import { getItineraryUpdates } from '../../api/api'

export const actionTypes = {
  FETCH_START: 'itineraryUpdates/FETCH_START',
  FETCH_SUCCESS: 'itineraryUpdates/FETCH_SUCCESS',
  FETCH_ERROR: 'itineraryUpdates/FETCH_ERROR',
}

export const fetchItineraryUpdates = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_START })

  try {
    const { data } = await getItineraryUpdates()
    return dispatch({ type: actionTypes.FETCH_SUCCESS, payload: data })
  } catch (error) {
    return dispatch({ type: actionTypes.FETCH_ERROR })
  }
}
